module.exports = __webpack_public_path__ + "img/meetting.b2325f2d.png";